<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" :overlay="false" scrollable max-width="900px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>group_add</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Upload new referrals</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text class="pa-0">
        <v-stepper vertical v-model="step">
          <v-stepper-step step="1" :complete="step > 1" editable class="ma-0">
            Upload a CSV file of Referrals
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card flat tile class="ma-0 mb-5">
              <v-card-text class="pa-0">
                <v-form lazy-validation>
                  <v-container fluid grid-list-md class="pa-0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12 sm12>
                            <p>
                              Please make sure you upload a csv, xls or xlsx file and your referral data is on the first
                              sheet. Please make sure you use the following column headers in the first row:
                            </p>
                            <p>
                              <strong
                                >'company_name', 'title', 'first_name', 'last_name', 'email', 'phone', 'address_1',
                                'address_2', 'address_3', 'address_4', 'address_5', 'post_code', 'requested_amount',
                                'finance_type_requested', 'legal_status', 'months_of_revenue', 'required_by',
                                'requested_on', 'bank_reference'</strong
                              >
                            </p>
                            <p><strong>Please ensure dates are in this format: dd/mm/yyyy</strong></p>
                          </v-flex>
                          <v-flex xs12 sm12 v-if="PlatformUser()">
                            <v-autocomplete
                              :items="RegistrationReferrerList"
                              item-text="name"
                              item-value="id"
                              v-model="businessId"
                              label="Referring business"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm12>
                            <file-upload
                              :businessId="businessId"
                              v-if="businessId !== null || !PlatformUser()"
                              v-on:uploadSuccess="showSummary"
                            />
                            <span v-else>Please select a referring business first</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="step > 2" :rules="[() => fileSaveSuccess !== false]" editable>
            Upload
            <small v-if="fileSaveSuccess === false">There was a problem uploading your file</small>
            <small v-else>Added referrals</small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-flex xs4>
              <v-card flat class="pa-0">
                <v-card-text v-if="fileSaveSuccess === true">
                  <v-alert type="success" :value="fileSaveSuccess">
                    Referral file successfully processed
                  </v-alert>
                  <referral-upload-table :ReferralUploads="ReferralUploads"></referral-upload-table>
                </v-card-text>
                <v-card-text v-else>
                  <v-alert type="error" :value="!fileSaveSuccess">
                    There was a problem uploading your file
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-btn color="accent" @click.native="closeDialog">Finish</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import FileUpload from './FileUpload';
import ReferralUploadTable from './ReferralUploadTable';

export default {
  components: {
    FileUpload,
    ReferralUploadTable
  },
  name: 'referral-upload-dialog',
  props: ['show'],
  data: () => ({
    step: 1,
    fileSaveSuccess: null,
    businessId: null
  }),
  computed: {
    ...mapGetters(['SelectedReferral', 'RegistrationReferrerList', 'ReferralUploads', 'PlatformUser']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['clearReferralUploads']),
    closeDialog() {
      this.dialog = false;
    },
    showSummary: function() {
      this.step = 2;
      this.fileSaveSuccess = true;
    },
    lowerCase: function(str) {
      return _.lowerCase(str);
    },
    isDefined: function(value) {
      return _.isUndefined(value) === false;
    },
    isFilled: function(value) {
      return !_.isEmpty(value);
    }
  },
  mounted() {
    this.clearReferralUploads();
  },
  watch: {
    show: function() {
      this.step = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
